/**
 * Filter menu script
 */
class P_FilterMenu {
    constructor() {
        this.initState();
    }

    initState() {
        this.filterSelect = $('.filter-item-select');

        if (this.filterSelect.length) {
            this.initEvents();
        }
    }

    initEvents() {
        for (let i = 0; i < this.filterSelect.length; i++) {
            this.activator = this.filterSelect.eq(i).find('.filter-item-activator');

            this.activator.on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                filterSelect.forEach(item => {
                    if (item !== filterSelect[i]) {
                        item.removeClass('active');
                    }
                });

                setTimeout(() => {
                    if (e.target.tagName !== 'BUTTON') {
                        filterSelect[i].toggleClass('active');
                    }
                }, 100);
            });
        }

        document.on('click', function (e) {
            filterSelect.forEach(item => {
                if (!item.contains(e.target)) {
                    item.removeClass('active');
                }
            });
        });
    }
}

